var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("page-" + (_vm.$route.name))},[_c('navbar'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('lazy-hydrate',{attrs:{"ssr-only":""}},[_c('footer-comp')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }